import { render } from "./SalesRapport.vue?vue&type=template&id=78450401&scoped=true&ts=true"
import script from "./SalesRapport.vue?vue&type=script&lang=ts"
export * from "./SalesRapport.vue?vue&type=script&lang=ts"

import "./SalesRapport.vue?vue&type=style&index=0&id=78450401&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78450401"]])

export default __exports__